import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconInfo from '@spothero/icons/info';
import IconChevronDown from '@spothero/icons/chevron-down';
import IconChevronUp from '@spothero/icons/chevron-up';
import TextButton from '@spothero/ui/text-button';
import Price from 'common/price/Price';
import AlertModal from 'common/alert/AlertModal';

const PriceBreakdownItem = ({
    className,
    item: {
        type,
        price,
        short_description: shortDescription,
        full_description: fullDescription,
    },
    currencyType,
    useInlineDescription,
}) => {
    const classes = classNames('PriceBreakdownItem', className);
    const [showFullDescription, setShowFullDescription] = useState(false);
    const toggleFullDescription = useCallback(
        () => setShowFullDescription(!showFullDescription),
        [showFullDescription]
    );

    return (
        <div className={classes}>
            <div className="PriceBreakdownItem-line-item">
                <span className="PriceBreakdownItem-label">
                    {!fullDescription && shortDescription}
                    {!useInlineDescription && fullDescription && (
                        <TextButton
                            className="PriceBreakdownItem-label-button"
                            onClick={toggleFullDescription}
                            iconPosition="right"
                        >
                            {shortDescription}
                            <IconInfo />
                        </TextButton>
                    )}
                    {useInlineDescription && fullDescription && (
                        <TextButton
                            className="PriceBreakdownItem-label-button"
                            onClick={toggleFullDescription}
                            iconPosition="right"
                        >
                            {shortDescription}
                            {showFullDescription ? (
                                <IconChevronUp />
                            ) : (
                                <IconChevronDown />
                            )}
                        </TextButton>
                    )}
                </span>
                <Price amount={price} currencyType={currencyType} showCents />
            </div>
            {useInlineDescription && showFullDescription && (
                <div className="PriceBreakdownItem-inline-description">
                    {fullDescription}
                </div>
            )}
            {!useInlineDescription && showFullDescription && (
                <AlertModal
                    className="PriceBreakdownItem-modal"
                    title={shortDescription}
                    message={fullDescription}
                    onHidden={toggleFullDescription}
                />
            )}
        </div>
    );
};

PriceBreakdownItem.propTypes = {
    className: PropTypes.string,
    item: PropTypes.shape({
        type: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        short_description: PropTypes.string.isRequired, // eslint-disable-line camelcase
        full_description: PropTypes.string, // eslint-disable-line camelcase
    }).isRequired,
    currencyType: PropTypes.string.isRequired,
    useInlineDescription: PropTypes.bool,
};

PriceBreakdownItem.defaultProps = {
    useInlineDescription: false,
};

export default PriceBreakdownItem;
